import type { GoogleDriveNodeFlat } from '../../api/google';

export type GoogleDriveTreeNode = {
  id: string;
  name: string;
  is_folder: boolean;
  mime_type: string;
  path: string;
  depth: number;
  children?: GoogleDriveTreeNode[];
};

const sortTreeNodes = (nodes: GoogleDriveTreeNode[]) => {
  nodes.sort((a, b) => {
    if (a.is_folder && !b.is_folder) return -1;
    if (!a.is_folder && b.is_folder) return 1;
    return a.name.localeCompare(b.name);
  });
  for (const node of nodes) {
    if (node.children) {
      sortTreeNodes(node.children);
    }
  }
};

export const buildGoogleDriveTree = (items: GoogleDriveNodeFlat[]) => {
  const nodeMap = new Map<string, GoogleDriveTreeNode>();
  const rootNodes: GoogleDriveTreeNode[] = [];

  for (const item of items) {
    nodeMap.set(item.id, {
      id: item.id,
      name: item.name,
      is_folder: item.is_folder,
      mime_type: item.mime_type,
      path: item.path,
      depth: item.depth,
      children: [],
    });
  }

  for (const item of items) {
    const node = nodeMap.get(item.id);
    if (!node) {
      continue;
    }
    if (item.parent_id && nodeMap.has(item.parent_id)) {
      const parentNode = nodeMap.get(item.parent_id);
      parentNode?.children?.push(node);
    } else {
      // Treat missing parents as root nodes to keep UI stable.
      rootNodes.push(node);
    }
  }

  sortTreeNodes(rootNodes);

  return rootNodes;
};
